<script setup>
import { computed, onMounted, reactive } from 'vue';
import { BANK_LIST, COMMENT_LIST, MODAL_TYPE } from '@/common/constants/ConstCode';
import { cloneDeep } from 'lodash';
import { showTextModal } from '@/common/utils/ModalState';

const props = defineProps(['data']);
const emits = defineEmits(['close']);
const { fnCallBack, fnCancelCallBack, defaultValue, errorText, maxLength } = props.data;

const contents = computed(() => props.data?.contents);

const state = reactive({
  object: 'KB 국민은행',
  textInput: ''
});

const bankList = cloneDeep(BANK_LIST);

onMounted(async () => {
  let isExistOption = bankList.some(item => item.value === defaultValue || defaultValue.includes('선택'));

  if (!isExistOption && defaultValue) {
    state.object = '직접입력';
    state.textInput = defaultValue;
  } else {
    state.object = defaultValue ?? bankList[0].value;
  }
  // state.object = bankList[0].value;
});

const fnSelect = () => {
  if (!state.object && !state.textInput) {
    showTextModal('은행을 선택해주세요.', '확인');
    return;
  }

  if (state.object === '직접입력') {
    if (!state.textInput) {
      showTextModal('은행명을 입력해주세요.', '확인');
      return;
    }
    fnCallBack(state.textInput);
    emits('close');
    return;
  }

  fnCallBack(state.object);
  emits('close');
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con">
            <div class="radio-box grid3">
              <label class="radio Large">
                <!--Large-->
                <input type="radio" name="radio_L" checked="" :value="'직접입력'" v-model="state.object" />
                <span class="radio-txt" style="letter-spacing: -0.08em; font-size: 1.2rem">직접입력</span>
              </label>
              <label class="radio Large" v-for="(item, index) in bankList" :key="index">
                <!--Large-->
                <input type="radio" name="radio_L" :value="item.value" v-model="state.object" />
                <span class="radio-txt" style="letter-spacing: -0.08em; font-size: 1.2rem">{{ item.content }}</span>
              </label>
            </div>
          </div>
          <div class="form-li mg-side16 mt10" v-if="state.object === '직접입력'">
            <div class="form-ttl essen">
              <!--필수값: essen-->
              <span>은행명</span>
            </div>
            <div class="form-in">
              <label class="label">
                <input type="text" placeholder="은행명을 입력해주세요" v-model="state.textInput" />
              </label>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn medium border-gray" @click="$emit('close')">닫기</button>
              <button class="btn primary medium" @click="fnSelect">선택</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
